import {combineReducers} from 'redux'
import AuthReducer from './authentication/reducer'
import AppReducer from './app/reducer'
import StateReducer from './state/reducer'

export const rootReducer = () => {
  return combineReducers({
    authentication: AuthReducer,
    app: AppReducer,
    state: StateReducer
  })
}
